import React from 'react';

function Link({
	children,
	href,
	...otherProps
}: {
	children: React.ReactNode;
	href: string;
}) {
	return (
		<a
			href={href}
			rel="noopener noreferrer"
			target="_blank"
			{...otherProps}
		>
			{children}
		</a>
	);
}

export default Link;
